import React from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction, IconButton, Tooltip, Box,
} from "@material-ui/core";
import ReactPlayer from "react-player/lazy";
import InfoIcon from "@material-ui/icons/Info";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import NumberFormat from "react-number-format";
import { videoBucketUrl } from "../../../server/constants";

function EstimationDetail(props: { age: number, estimationData: any, totalContribution?: string | number }) {
  const {age, estimationData} = props;
  const btnVideoUrl: string = `${videoBucketUrl}/kai-zen-strategies-how-contributions-works-animation.mp4`;
  return (
    <div className="sectionPD" >
      <Grid container justifyContent="center" >
        <Grid item xs={12}>
          <Typography variant="h2" className="mt30 textCenter mb40" color="primary">Your Results Are Below</Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={7}>
          <Grid container justifyContent="center">
            <Grid item xs={12}>

              <Typography variant="subtitle1" component="strong" className="mt30 ">Policy funding</Typography>
              <Typography variant="body1" align="left" className="mb20">Your contributions are used to purchase death
                benefit protection that can provide cash in the event of a chronic or terminal
                illness. The excess funds have the potential to accumulate and grow over time, which
                can be used to help supplement your retirement.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Typography variant="subtitle1" component="strong" className="mb15 w100">
                Benefits and distributions by age
              </Typography>
              <Typography variant="caption" className="floatLeft mr30 w100"><FiberManualRecordIcon
                className="colorYellow floatLeft"
                style={{marginTop: "-4px"}}/> Protection</Typography>
              <Typography variant="caption" className="floatLeft w100"><FiberManualRecordIcon
                className="colorBlue floatLeft"
                style={{marginTop: "-4px"}}/> Accumulation</Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <div className="returnRateBox">
                <Typography variant="caption" className="f14"><b>Internal Rate of Return</b></Typography>
                <NumberFormat
                  value={estimationData.kaizen_levd_irr}
                  displayType={"text"}
                  thousandSeparator={false} suffix={"%"}
                  renderText={value => (
                    <Box className="f22 floatLeft textHighLight" component="strong">
                      {value}
                      <Tooltip
                        arrow
                        color="primary"
                        title="IRR (internal rate of return) is the return on your investment, net of taxes and costs, and useful for comparing investments of the same risk profile. Stock portfolio would be a higher risk with greater chance of loss, whereas bonds would be a lower risk."
                      >
                        <IconButton aria-label="Info">
                          <InfoIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  )}
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <Card className="benefitsCard bgLightGray mt40 mb20">
                <CardContent className="benefitsCardContent">
                  <List>
                    <ListItem disableGutters={true}>
                      <ListItemAvatar>
                        <></>
                      </ListItemAvatar>
                      <ListItemText primary={
                        <React.Fragment>
                          <Typography
                            component="strong"
                            variant="subtitle2"
                            className="mb0"
                          >
                            Age {age}
                          </Typography>
                        </React.Fragment>
                      }/>
                    </ListItem>
                    <ListItem disableGutters={true}>
                      <ListItemAvatar>
                        <FiberManualRecordIcon
                          style={{marginTop: "-23px", float: "left"}}
                          className="colorYellow"/>
                      </ListItemAvatar>
                      <ListItemText
                        primary="Initial death benefit protection"
                        secondary="Access to living benefit riders"/>
                      <ListItemSecondaryAction>
                        <Typography variant="subtitle1" className="mb0 valueText">
                          <NumberFormat
                            value={estimationData.kaizen_initial_death_benefit}
                            displayType={"text"}
                            thousandSeparator={true} prefix={"$"}
                            renderText={value => <Box className="f22 floatLeft" component="strong">{value}</Box>}
                          />
                          <Tooltip
                            color="primary"
                            title="Initial death benefit." arrow>
                            <IconButton aria-label="Info">
                              <InfoIcon/>
                            </IconButton>
                          </Tooltip>
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </CardContent>
              </Card>
              <Card className="benefitsCard bgLightGray mt40 mb20">
                <CardContent className="benefitsCardContent">
                  <List>
                    <ListItem disableGutters={true}>
                      <ListItemAvatar>
                        <></>
                      </ListItemAvatar>
                      <ListItemText primary={
                        <React.Fragment>
                          <Typography
                            component="strong"
                            variant="subtitle2"
                            className="mb0"
                          >
                            Ages {estimationData.assumption_age_begins} - 90
                          </Typography>
                        </React.Fragment>
                      }/>
                    </ListItem>
                    <ListItem disableGutters={true}>
                      <ListItemAvatar>
                        <FiberManualRecordIcon
                          style={{marginTop: "-23px", float: "left"}}
                          className="colorBlue"/>
                      </ListItemAvatar>
                      <ListItemText
                        primary="Begin potential tax-free distributions"
                        secondary="when using policy loans"/>
                      <ListItemSecondaryAction>
                        <Typography variant="subtitle1" className="mb0 valueText">
                          <NumberFormat
                            value={estimationData.kaizen_annual_income}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            renderText={value => <Box className="f22 floatLeft" component="strong">{value}</Box>}
                          />
                          / yr
                          <Tooltip
                            arrow color="primary" title="This is an estimation of policy distributions taken annually."
                          >
                            <IconButton aria-label="Info">
                              <InfoIcon />
                            </IconButton>
                          </Tooltip>
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </CardContent>
              </Card>
              <Card className="benefitsCard bgLightGray mt40 mb20">
                <CardContent className="benefitsCardContent">
                  <List>
                    <ListItem disableGutters={true}>
                      <ListItemAvatar>
                        <></>
                      </ListItemAvatar>
                      <ListItemText primary={
                        <React.Fragment>
                          <Typography
                            component="strong"
                            variant="subtitle2"
                            className="mb0"
                          >
                            Age 90
                          </Typography>
                        </React.Fragment>
                      }/>
                    </ListItem>
                    <ListItem disableGutters={true}>
                      <ListItemAvatar>
                        <FiberManualRecordIcon style={{float: "left"}} className="colorBlue"/>
                      </ListItemAvatar>
                      <ListItemText
                        primary={`Cumulative distributions taken from age ${estimationData.assumption_age_begins}-90`}
                      />
                      <ListItemSecondaryAction>
                        <Typography variant="subtitle1" className="mb0 valueText">
                          <NumberFormat
                            value={estimationData.kaizen_total_income}
                            displayType={"text"}
                            thousandSeparator={true} prefix={"$"}
                            renderText={value => <Box className="f22 floatLeft" component="strong">{value}</Box>}
                          />
                          <Tooltip
                            arrow
                            color="primary"
                            title="This is the total amount of distributions taken through age 90.">
                            <IconButton aria-label="Info">
                              <InfoIcon/>
                            </IconButton>
                          </Tooltip></Typography>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem disableGutters={true}>
                      <ListItemAvatar>
                        <FiberManualRecordIcon style={{float: "left"}} className="colorYellow"/>
                      </ListItemAvatar>
                      <ListItemText
                        primary="Remaining death benefit for beneficiaries net of all loan repayments."
                      />
                      <ListItemSecondaryAction>
                        <Typography variant="subtitle1" className="mb0 valueText">
                          <NumberFormat
                            value={estimationData.kaizen_death_benefit_yr90}
                            displayType={"text"}
                            thousandSeparator={true} prefix={"$"}
                            renderText={value => <Box className="f22 floatLeft" component="strong">{value}</Box>}/>
                          <Tooltip
                            arrow
                            color="primary"
                            title="The amount paid to a beneficiary upon the death of an insured person. Death benefits start out higher depending on your age and health. The amount shown here is the remaining amount at age 90 after policy distributions."
                          >
                            <IconButton aria-label="Info">
                              <InfoIcon/>
                            </IconButton>
                          </Tooltip>
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6} lg={5}>
          <ReactPlayer
            autoPlay={true}
            className="tabTwoVideo"
            controls={false}
            height='800px'
            loop={true}
            muted={true}
            playing={true}
            playsinline={true}
            url={btnVideoUrl}
            volume={0}
            width='100%'
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default EstimationDetail;
